// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".HongKong-map[data-v-2e033f62] {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.HongKong-map[data-v-2e033f62],\n.map-label[data-v-2e033f62] {\n  font-size: 12px;\n  color: #ffffff;\n}", ""]);
// Exports
module.exports = exports;
